export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-die-four-cab8e1fb37bfaca5be3c5c1a4f19e563.svg";